import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Convert from './plugins/Convert'
import VeeValidate from './plugins/VeeValidate'
import VueQuillEditor from '@/plugins/VueQuillEditor'
import VueAwesomeCountdown from '@/plugins/vueAwesomeCountdown'
import VuePdf from "@/plugins/VuePdf"
import VueMasonry from '@/plugins/VueMasonry' 

import '@/assets/css/main.css'

import { TokenService } from '@/service/Storage.Service.js'

if (TokenService.getToken()) {
  store.commit('setToken', TokenService.getToken())
  store.commit('setUser', JSON.parse(TokenService.getUser()))
  store.commit('setBill', JSON.parse(TokenService.getBill()))
}

store.commit('setEmail', TokenService.getEmail())

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueAwesomeCountdown,
  VuePdf,
  VueMasonry,
  render: h => h(App)
}).$mount('#app')
